import React, { Component } from "react";
import { Link } from "react-router-dom";
import Contentify from "../../../content/Contentify";
import { ButtonConfig } from "../../../constants/Constants";
import { Paths } from "../../../constants/UrlConstants";
import linkStyles from "../../../assets/css/modules/shared/link.css";

class SmartLink extends Component {
  render() {
    let link;

    if (this.props.to) {
      if(this.props.isDisabled)
      {
        link = (
          <Link to="/" id={this.props.id} className={this.props.disableStyle ?linkStyles.disabled:this.props.className} onClick={ (event) => event.preventDefault() }>{this.props.children}</Link>
        );
      }
      else if (this.props.isExternalLink) {
        link = (
          <a
            id={this.props.UniqueKey === "GPSection" ? 
                      ButtonConfig.PromoMoreAboutService : 
                      this.props.UniqueKey ==="mskBanner" ?
                      this.props.accessPage === Paths.HowToClaim ||
                      this.props.accessPage === Paths.Claims ||
                      this.props.accessPage === Paths.Cover ||
                      this.props.accessPage === Paths.MyProfileContactPreferences ||
                      this.props.accessPage === Paths.CommunicationPreference ?
                      ButtonConfig.MSkpromo:
                      ButtonConfig.HatHPromo : this.props.id}
            href={this.props.to}
            target="_blank"
            rel="noopener"
            className={this.props.className}
            aria-label={this.props["aria-label"]}
          >
            {this.props.children}
          </a>
        );
      } else {
        link = (
          <Link
            id={this.props.UniqueKey === "GPSection" ? 
            ButtonConfig.PromoMoreAboutService : 
            this.props.UniqueKey ==="mskBanner" ?  this.props.accessPage === Paths.HowToClaim ||
            this.props.accessPage === Paths.Claims ||
            this.props.accessPage === Paths.Cover ||
            this.props.accessPage === Paths.MyProfileContactPreferences ||
            this.props.accessPage === Paths.CommunicationPreference ?
            ButtonConfig.MSkpromo:
            ButtonConfig.HatHPromo : this.props.id}
            to={this.props.to}
            className={this.props.className}
            aria-label={this.props["aria-label"]}
          >
            {this.props.children}
          </Link>
        );
      }
    }

    return <div>{link}</div>;
  }
}

export default Contentify(SmartLink);
